import { gray } from 'src/features/muikds/kdsColors'
import { semanticColors } from '../../../theme/semanticColors'

export const containerSx = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
} as const

export const iconBoxSx = {
  display: 'flex',
  flexDirection: 'row',
  gap: 1,
} as const

export const infoIconSx = {
  color: '#1976D2',
  fontSize: '22px',
} as const

export const attachFileIconSx = {
  color: '#1976D2',
  fontSize: '18px',
  left: '-2px',
} as const

export const baseTextSx = {
  fontFamily: 'Noto Sans JP',
  color: semanticColors.colorTextBase,
} as const

export const infoTextSx = {
  ...baseTextSx,
  fontWeight: 700,
  fontStyle: 'Bold',
  fontSize: '16px',
} as const

export const stepTitleSx = {
  ...baseTextSx,
  fontWeight: 400,
  fontSize: '16px',
} as const

export const stepNoteSx = {
  ...baseTextSx,
  fontWeight: 400,
  fontSize: '12px',
} as const

export const csvUploadTitleSx = {
  ...baseTextSx,
  fontWeight: 700,
  fontStyle: 'Bold',
  fontSize: '16px',
} as const

export const selectedFileSx = {
  ...baseTextSx,
  fontWeight: 400,
  fontSize: '13px',
  color: '#3B5BDB',
} as const

export const instructionContainerSx = {
  border: '1px solid #3B5BDB',
  borderRadius: 1,
  padding: 2,
  gap: 1,
  display: 'flex',
  flexDirection: 'column',
} as const

export const instructionStepsContainerSx = {
  display: 'flex',
  flexDirection: 'column',
  height: '244px',
  gap: 2,
  paddingLeft: '34px',
} as const

export const stepContainerSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
} as const

export const stepButtonContainerSx = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  gap: 1,
} as const

export const csvUploadSectionSx = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  gap: 1,
} as const

export const footerSx = {
  padding: 3,
  gap: 2,
  display: 'flex',
  justifyContent: 'flex-end',
  borderTop: 1,
  borderColor: 'divider',
  backgroundColor: gray[2],
} as const
